import React from "react";
import PanelGroupController from "../../../components/PanelGroupController";
import {fromJS} from "immutable";
import PropertiesList from "../../../components/panels/PropertiesList";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {Query} from "react-apollo";
import {WATER_PALLET} from "../../../queries/inventory";

const WaterPalletPropertiesPanel = (props) => {

  let elements = null;
  if (!props.selectedPalletId) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let items = fromJS([
      {prop: "palletId", label: "Pallet id", type: "string"},
      {prop: "state", label: "State", type: "string"},
      {prop: "skus", label: "SKU(s)", type: "array"},
      {prop: "items", label: "Items", type: "string"},
      {prop: "createdAt", label: "Recorded", type: "utc"}
    ])
    //
    let testResults = fromJS([
      {prop: "testCategory", label: "Test Results", type: "category"},
      {prop: "testResult", label: "Result", type: "string"},
      {prop: "testLabName", label: "Lab", type: "string"},
      {prop: "testNr", label: "Test nr.", type: "string"}
      // {prop: "test_recorded_at", label: "Recorded", type: "utc"}
    ])    
    let variables = {palletId: props.selectedPalletId}
    elements = (
      <Query query={WATER_PALLET} variables={variables} skip={!props.selectedPalletId}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          let pallet = fromJS(data.waterPallet);
          let properties = (pallet.get("testResult") === "pending") ? items : items.concat(testResults);
          return (
            <PropertiesList properties={properties} data={pallet} />
          )
        }}
      </Query>
    )
  }

  return (
    <PanelGroupController title="Water Pallet" expanded={props.expanded}>
      {elements}
    </PanelGroupController>
  )

}

export default WaterPalletPropertiesPanel;